<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
    <el-form-item label="通知内容">
      <el-input
        type="textarea"
        v-model="ruleForm.SettingContent"
        :rows="10"
        style="width: 79rem"
      ></el-input>
    </el-form-item>
  </el-form>
</template>
<script>
//import MyApis from "../../../apis";
export default {
  name: "ZjComponentAPPDetail",
  controller: "UI",
  action: "ComponentAPPDetail",
  props: {
    PlanTaskId: String,
    TaskSubTypeId: String,
  },
  data() {
    return {
      ruleForm: {
        SettingContent: "",
      },
    };
  },
  created: function () {},
  methods: {
    Gettaskreceiver() {
      var tasksett = {};

      tasksett.OrgId = this.user.deptId;
      //tasksett.SettingId = utils.uuid();
      tasksett.PlanTaskId = this.PlanTaskId;
      tasksett.SettingContent = this.ruleForm.SettingContent;
      tasksett.TaskSubTypeId = this.TaskSubTypeId;

      return { TaskSettingDTO: tasksett, TaskReceiverDTO: [] };
    },
  },
};
</script>